module.exports = __webpack_public_path__ + "img/whatsapp.68fd53e2.svg";